'use es6';

import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { getModuleSpec, getTranslatedModuleLabel } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getIsSingleColumnFullWidth } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import CommentableArea from './CommentableArea';
import { isHiddenForDefaultBreakpoint, isHiddenForMobileBreakpoint } from 'EmailEditorUI/utils/breakpointUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ElementCommentableArea({
  children,
  element
}) {
  const elementId = element.get('id');
  const moduleSpec = useSelector(state => getModuleSpec(state, element));
  const isSingleColumnFullWidth = useSelector(getIsSingleColumnFullWidth);
  const label = useSelector(state => moduleSpec && getTranslatedModuleLabel(state, moduleSpec.displayName || moduleSpec.name, moduleSpec.moduleId));
  const altLabel = useMemo(() => {
    const imageAlt = element.getIn(['body', 'img', 'alt'], null);
    const textAlt = element.getIn(['body', 'text'], null);
    const embedAlt = element.getIn(['body', 'embed', 'oembed_response', 'title'], null);
    return imageAlt || textAlt || embedAlt;
  }, [element]);
  const description = useMemo(() => ({
    translationKey: altLabel ? 'emailElementWithAlt' : 'emailElement',
    options: Object.assign({
      label
    }, altLabel ? {
      altLabel
    } : {})
  }), [altLabel, label]);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(CommentableArea, {
      className: classNames("commentable-element position-relative", element && [isHiddenForDefaultBreakpoint(element.get('styles')) && 'hs-hd', isHiddenForMobileBreakpoint(element.get('styles')) && 'hs-hm']),
      moduleId: elementId,
      offsetOutline: true,
      description: description,
      iconPosition: isSingleColumnFullWidth ? {
        top: '-22px',
        left: '10px'
      } : undefined,
      children: children
    }, elementId)
  );
}
ElementCommentableArea.propTypes = {
  children: PropTypes.node,
  elementId: PropTypes.string.isRequired
};